<form
  [signalForm]="configForm"
  class="flex min-h-0 flex-1 flex-col gap-6  px-4 py-4">
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Configuration
    </h3>
    <lib-signal-text-field
      label="Label"
      [formField]="configForm.label" />
    <lib-signal-text-field
      label="Help Text"
      [formField]="configForm.helpText" />
    <lib-signal-checkbox
      label="Required"
      [formField]="configForm.required" />
    <lib-signal-button [appearance]="'primary'" [type]="'button'" (click)="useCurrentLocation()">Use Current Location
    </lib-signal-button>
    <app-google-address-auto-complete
      label="Default location"
      placeholder="Search for a default location"
      (locationSelected)="onLocationSelected($event)" />
    @if (defaultLocation(); as location) {
      <p class="text-xs leading-5 text-slate-500">
        {{ location.address }}
        <span class="mt-0.5 block text-slate-400">
          {{ location.latitude }}, {{ location.longitude }}
        </span>
      </p>
    }
  </section>
</form>
